module.exports = __webpack_public_path__ + "fonts/SourceSansPro-SemiBold.550b42a5.ttf";